import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-add-edit-user-actions-modal',
  templateUrl: './add-edit-user-actions-modal.component.html'
})
export class AddEditUserActionsModalComponent {

  modalData: any;
  clientOrBuLabel: string;

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService
  ) {
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
    this.clientOrBuLabel = this.modalData.isCorporate ? 'BU' : 'Client';
  }

  closeModal() {
    this.bsModalRef.hide();
  }
}
